module.exports = __webpack_public_path__ + "img/logo.50b4e00e.png";